import MenuSelector from '../MenuSelector';
import Checkbox from '@material-ui/core/Checkbox';
import withWidth from '@material-ui/core/withWidth';
import PrimaryButton from '../PrimaryButton';
import SecondaryButton from '../SecondaryButton';
import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import CancelButton from '../CancelButton';
import PartnerLegal from '../PartnerLegal';
import catalog from './catalog.json';
import exampleData from './examples.json';
import { globalStyles } from '../style/gstheme';

const DISPLAY_SPONSORS = true;

const styles = (theme) => {
    return Object.assign({
        provider: {
            marginLeft: 36,
            padding: '3px 12px',
            display: 'inline-block',
            verticalAlign: 'middle',
            cursor: 'pointer',
            '&:focus-visible': {
                outline: 'dashed 2px black'
            }
        },
        dataset: {
            color: theme.palette.primary.main,
            borderRadius: 4,
            padding: 12,
            overflow: 'auto',
            border: 'solid 1px #c0c0c0',
            '&:hover': {
                boxShadow: '0px 12px 17px #00000024'
            }
        },
        summary: {
            height: 90
        },
        smallSummary: {
        },
        datasetInfo: {
            display: 'flex',
            marginBottom: 12,
        },
        licenceInfo: {
            marginTop: 12
        },
        more: {
            '&:hover': {
                cursor: 'pointer'
            },
            '&:focus-visible': {
                outline: 'dashed 2px black'
            }
        },
        playIcon: {
            height: 60,
            width: 60,
            color: theme.palette.secondary.main,
            '&:hover': {
                cursor: 'pointer',
                color: theme.palette.secondary.dark
            }
        },
        playExample: {
            paddingTop: 30,
            width: 60,
            marginLeft: 36
        }
    }, globalStyles);
};

class MarketplaceDialog extends React.Component {

    state = {
        title: "",
        description: "",
        sponsor: 0,
        legal: false,
        acceptConditions: false,
        iriType: "Slash",
        orderType: "Ordered",
        defaultToXL: false,
        iriFormat: "UUID",
        isValidIRI: false,
        catalogItem: null,
        componentIRI: ""
    };

    exitMarketplace = () => {
        this.props.onExitMarketplace();
    };

    loadExample = (ds) => this.props.loadExample(ds);

    expand = (index) => {
        const isExpanded = this.state[index] || false;
        this.setState({ [index]: !isExpanded });
    };

    selectSponsor = (sponsor) => {
        this.setState({
            sponsor,
            acceptConditions: false,
            catalogItem: null,
            legal: false,
            0: false,
            1: false,
            2: false,
            3: false,
            4: false,
            5: false,
            6: false
        });
    };

    handleChangeConditions = (event) => this.setState({ acceptConditions: event.target.checked });

    handleCatalogChange = (catalogItem) => this.setState({ catalogItem });

    showLegal = () => this.setState({ legal: true });

    exitLegal = () => this.setState({ legal: false });

    render() {

        const { classes, width } = this.props;
        const { acceptConditions, legal, catalogItem } = this.state;
        const selected = this.state.sponsor;
        const ed = exampleData[selected];
        const providerCatalog = selected === 0 ?
            []
            :
            catalog[ed.name].map(item => ({
                value: item.title,
                label: item.title
            }));
        const catalogItemData = catalogItem ?
            catalog[ed.name].find(pc => pc.title === catalogItem)
            :
            {};

        return (
            <Dialog
                data-test="market-place-dialog"
                maxWidth="lg"
                fullWidth
                classes={{
                    paper: classes.paper
                }}
                open={true} onClose={this.exitMarketplace} aria-labelledby="marketplace-dialog-title">
                <DialogTitle disableTypography className={classes.mainHeading} style={{ marginBottom: 0 }} id="marketplace-dialog-title">Example Projects</DialogTitle>
                <DialogContent style={{ height: DISPLAY_SPONSORS ? 500 : 440 }}>
                    {DISPLAY_SPONSORS &&
                        <div style={{ marginBottom: 20, display: 'flex' }}>
                            <Typography variant="h2" className={classes.subMainHeading}>Select Provider</Typography>
                            {exampleData.map((ed, index) =>
                                <div
                                    data-test={"provider-" + index}
                                    tabIndex={0}
                                    aria-label={"Select " + ed.name}
                                    key={index} className={classes.provider}
                                    onKeyDown={(ev) => {
                                        if (ev.key === "Enter") {
                                            ev.preventDefault();
                                            ev.stopPropagation();
                                            this.selectSponsor(index);
                                        }
                                    }}
                                    onClick={() => this.selectSponsor(index)}
                                    style={{
                                        borderBottom: selected === index ? 'solid 3px #97d700' : 'solid 3px #fff'
                                    }}>
                                    <img alt="" src={'/images/' + ed.icon} style={{ height: 30 }} />
                                </div>
                            )}
                        </div>
                    }
                    <div style={{ display: 'flex' }}>
                        <Grid container spacing={6}>
                            {DISPLAY_SPONSORS && ed.benefits &&
                                <Grid data-test="benefits" item xs={12} md={6} lg={4}>
                                    <Typography className={classes.mainHeading}>The Benefits to You</Typography>
                                    <Typography paragraph variant="caption"><a href={ed.site} target="_new">{ed.site}</a></Typography>
                                    <div data-test="benefits">
                                        {ed.benefits.map((line, index) => <Typography paragraph key={index} variant="body2">{line}</Typography>)}
                                    </div>
                                    <div>
                                        <div style={{ float: 'right', display: 'flex' }}>
                                            <div style={{ flex: '0 0' }}>
                                                <Checkbox data-test="accept-ts-and-cs" checked={acceptConditions} onChange={this.handleChangeConditions} name="conditions" />
                                            </div>
                                            <div style={{ flex: '1', paddingTop: 12, textAlign: 'left' }}>
                                                <Typography data-test="tc-link" className={classes.legalLink} style={{ textAlign: 'left' }} onClick={this.showLegal}>Accept {ed.name} Terms of Use</Typography>
                                            </div>
                                        </div>
                                    </div>
                                    <PartnerLegal open={legal} text={ed.terms} exitLegal={this.exitLegal} />
                                </Grid>
                            }
                            {ed.datasets.map((ds, index) =>
                                <Grid item xs={12} md={6} lg={4} key={index}>
                                    <div data-test={"example-" + (index + 1)} className={classes.dataset} style={{ backgroundColor: '#fafafa' }}>
                                        <div className={classes.datasetInfo}>
                                            <div>
                                                <div className={width === "xs" || width === "sm" ? classes.smallSummary : classes.summary}>
                                                    <Typography data-test="example-name" className={classes.mainHeading}>{ds.name}</Typography>
                                                    <Typography data-test="example-desc" paragraph variant="body2">{ds.description}</Typography>
                                                </div>
                                                <Typography
                                                    data-test="more-less"
                                                    tabIndex={0}
                                                    className={classes.more}
                                                    variant="caption"
                                                    onKeyDown={(ev) => {
                                                        if (ev.key === "Enter") {
                                                            ev.preventDefault();
                                                            ev.stopPropagation();
                                                            this.expand(index);
                                                        }
                                                    }}
                                                    onClick={() => this.expand(index)}>{
                                                        this.state[index] !== true ?
                                                            'More ...'
                                                            :
                                                            'Less ...'}</Typography>
                                            </div>
                                        </div>
                                        {this.state[index] === true ?
                                            <div data-test="expanded-desc" style={{ height: 272, overflow: 'scroll', paddingRight: 12 }}>
                                                {ds.more.map((line, index) => <Typography paragraph key={index} variant="body2">{line}</Typography>)}
                                            </div>
                                            :
                                            <div data-test="example-image" style={{ marginTop: 20, textAlign: 'center', marginBottom: 20 }}>
                                                <img alt="" src={'/images/' + ds.image} style={{ width: 'calc(100% - 20px)', marginBottom: 12, border: 'solid 1px #e0e0e0' }} />
                                                <PrimaryButton
                                                    disabled={selected !== 0 && !acceptConditions}
                                                    dataTest="load-example"
                                                    onClick={() => this.loadExample(ds)}>{"Load " + ds.name}</PrimaryButton>
                                            </div>
                                        }
                                    </div>
                                </Grid>
                            )}
                            {DISPLAY_SPONSORS && ed.buyInfo &&
                                <Grid item xs={12} md={12} lg={4}>
                                    <Typography className={classes.mainHeading}>More Information...</Typography>
                                    <div data-test="more-info">
                                        {ed.buyInfo.map((line, index) => <Typography paragraph key={index} variant="body2">{line}</Typography>)}
                                        <div style={{ marginBottom: 12 }}>
                                            <MenuSelector
                                                dataTest="catalog-selector"
                                                handleChange={this.handleCatalogChange}
                                                hintWord="taxonomy for more detail"
                                                options={providerCatalog} />
                                            {catalogItem &&
                                                <div style={{ marginTop: 6, marginBottom: 12, maxHeight: 155, overflow: 'scroll' }}>
                                                    <Typography data-test="catalog-desc" paragraph variant="body2">{catalogItemData.description}</Typography>
                                                    <Typography variant="caption">{catalogItemData.preferredTerms} Concepts. {catalogItemData.synonyms} Synonyms.</Typography>
                                                </div>
                                            }
                                        </div>
                                        <Typography paragraph variant="body2">Have a chat with Graphifi experts to find out more.</Typography>
                                        <a href="https://graphologi.com/contact" target="_new">
                                            <SecondaryButton
                                                dataTest="contact-us">Contact Us</SecondaryButton>
                                        </a>
                                    </div>
                                </Grid>
                            }
                        </Grid>
                    </div>
                </DialogContent>
                <DialogActions className={classes.dialogActions}>
                    <CancelButton onClick={this.exitMarketplace} />
                </DialogActions>
            </Dialog>
        );
    }
}

MarketplaceDialog.propTypes = {
    classes: PropTypes.object,
    width: PropTypes.string,
    onExitMarketplace: PropTypes.func.isRequired,
    loadExample: PropTypes.func.isRequired
};

export default withWidth()(withStyles(styles)(MarketplaceDialog));